// removed by extract-text-webpack-plugin
module.exports = {"horizontal":"theme__horizontal__35W5m8F3","vertical":"theme__vertical__21b0lzaI"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-toolbox/lib/navigation/theme.css
// module id = 904
// module chunks = 0